import * as React from 'react';

import StyledCoachTriggerButton, {
  type Props as StyledCoachTriggerButtonProps,
} from 'bundles/unified-common/components/coach-on-discovery/StyledCoachTriggerButton';

const StyledCoachTriggerButtonWithAnimationOnMount = (props: StyledCoachTriggerButtonProps) => {
  return <StyledCoachTriggerButton showAnimationOnMount={true} {...props} />;
};

export default StyledCoachTriggerButtonWithAnimationOnMount;
